import React from 'react';
import { motion } from 'framer-motion';

export interface ConnectedDeviceItemProps {
  label: string;
  toastName?: string;
  top: string;
  left: string;
  width: string;
  height: string;
  delay?: number;
  colorScheme?: 'cyan' | 'amber' | 'emerald';
  textSize?: string;
  flexCol?: boolean;
}

const COLOR_SCHEMES = {
  cyan: {
    button: 'border-cyan-400 bg-cyan-900/90 hover:bg-cyan-800 hover:border-cyan-300',
    text: 'text-cyan-200'
  },
  amber: {
    button: 'border-amber-400 bg-amber-900/90 hover:bg-amber-800 hover:border-amber-300',
    text: 'text-amber-200'
  },
  emerald: {
    button: 'border-emerald-400 bg-emerald-900/90 hover:bg-emerald-800 hover:border-emerald-300',
    text: 'text-emerald-200'
  }
};

export function ConnectedDeviceItem({
  label,
  toastName,
  top,
  left,
  width,
  height,
  delay = 0.2,
  colorScheme = 'cyan',
  textSize = 'text-[0.7rem]',
  flexCol = false
}: ConnectedDeviceItemProps) {
  const scheme = COLOR_SCHEMES[colorScheme];

  return (
    <motion.button
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay }}
      onClick={(e) => {
        e.stopPropagation();
        window.dispatchEvent(
          new CustomEvent('device-toast', { detail: { name: toastName || label, alias: label } })
        );
      }}
      className={`absolute rounded-md ${scheme.button} flex ${flexCol ? 'flex-col' : ''} items-center justify-center pointer-events-auto cursor-pointer transition-all shadow-lg`}
      style={{ top, left, width, height }}
    >
      <span className={`${textSize} font-mono font-bold ${scheme.text} uppercase tracking-wider`}>
        {label}
      </span>
    </motion.button>
  );
}
